import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";
const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const PRI = [
  { key: "p1", label: "P1 — Critical", color: "#f87171"  },
  { key: "p2", label: "P2 — High",     color: "#fb923c"  },
  { key: "p3", label: "P3 — Medium",   color: "#fbbf24"  },
  { key: "p4", label: "P4 — Low",      color: "#60a5fa"  },
];

export default function SlaPanel() {
  const [loading, setLoading] = useState(true);
  const [saving,  setSaving]  = useState(false);
  const [msg,     setMsg]     = useState(null);
  const [cfg, setCfg] = useState({
    businessHours: "09:00-18:00", holidays: 0,
    p1: { first: 1,  resolve: 4  },
    p2: { first: 4,  resolve: 24 },
    p3: { first: 24, resolve: 72 },
    p4: { first: 48, resolve: 168},
  });
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetch(`${API}/api/admin/tickets/sla`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => setCfg({
        businessHours: d.business_hours || "09:00-18:00",
        holidays: d.holidays || 0,
        p1: { first: d.p1_first_response || 1,  resolve: d.p1_resolution || 4   },
        p2: { first: d.p2_first_response || 4,  resolve: d.p2_resolution || 24  },
        p3: { first: d.p3_first_response || 24, resolve: d.p3_resolution || 72  },
        p4: { first: d.p4_first_response || 48, resolve: d.p4_resolution || 168 },
      }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const set = (path, v) => setCfg(prev => {
    const copy = structuredClone(prev);
    const parts = path.split(".");
    let cur = copy;
    for (let i = 0; i < parts.length - 1; i++) cur = cur[parts[i]];
    cur[parts.at(-1)] = v;
    return copy;
  });

  const save = async () => {
    setSaving(true); setMsg(null);
    try {
      const res = await fetch(`${API}/api/admin/tickets/sla`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({
          business_hours: cfg.businessHours, holidays: cfg.holidays,
          p1_first_response: cfg.p1.first, p1_resolution: cfg.p1.resolve,
          p2_first_response: cfg.p2.first, p2_resolution: cfg.p2.resolve,
          p3_first_response: cfg.p3.first, p3_resolution: cfg.p3.resolve,
          p4_first_response: cfg.p4.first, p4_resolution: cfg.p4.resolve,
        }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setMsg("✓ SLA policies saved.");
    } catch (e) { setMsg(`⚠ ${e.message}`); }
    finally { setSaving(false); }
  };

  if (loading) return <div className={`${card} p-5`}><div className="h-32 rounded-lg bg-white/5 animate-pulse" /></div>;

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">SLA Policies</span>
        <button onClick={save} disabled={saving}
          className="text-xs px-4 py-1.5 rounded-lg bg-[#00ff90]/15 text-[#00ff90] border border-[#00ff90]/30 hover:bg-[#00ff90]/25 disabled:opacity-40 transition-colors">
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
      <div className="p-5 space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <div><label className={labelCls}>Business Hours</label>
            <input className={inputCls} value={cfg.businessHours} onChange={e => set("businessHours", e.target.value)} placeholder="09:00-18:00" /></div>
          <div><label className={labelCls}>Public Holidays / year</label>
            <input type="number" className={inputCls} value={cfg.holidays} onChange={e => set("holidays", Number(e.target.value))} /></div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {PRI.map(({ key, label, color }) => (
            <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-4">
              <p className="text-xs font-semibold mb-3" style={{ color }}>{label}</p>
              <div className="space-y-2">
                <div>
                  <label className="text-xs text-white/30 block mb-1">First Response (hrs)</label>
                  <input type="number" min={0} className={inputCls} value={cfg[key].first}
                    onChange={e => set(`${key}.first`, Number(e.target.value))} />
                </div>
                <div>
                  <label className="text-xs text-white/30 block mb-1">Resolution (hrs)</label>
                  <input type="number" min={0} className={inputCls} value={cfg[key].resolve}
                    onChange={e => set(`${key}.resolve`, Number(e.target.value))} />
                </div>
              </div>
            </div>
          ))}
        </div>
        {msg && <p className={`text-xs ${msg.startsWith("⚠") ? "text-red-400" : "text-[#00ff90]"}`}>{msg}</p>}
      </div>
    </div>
  );
}